import { preReqs } from '../../Utility/Services'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const ReqProvider = (props) => {

    /* Adding Pre-Reqs to Utility Obj */
    preReqs(useDispatch, useNavigate)

    return (props.children)
    
}

export default ReqProvider